module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAVUlEQVRo3u3PQQ0AIAwEwZpCACJwiD8kFA/lQ5O5ZP83kZnRudbnAQAAAD4BxNpZ7XVnjnIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHVA5wAAAAAAnrolNtw4DqKSiAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/France.png
// module id = 275
// module chunks = 0